import { isCapabilitySupported } from "owa-capabilities";
import { favoritesCapability } from "owa-capabilities-definitions/lib/favoritesCapability";
import type { MailboxInfo } from "owa-client-types";
import { isPrioritizeOnDemandOn } from "owa-copilot-settings-utils";
import { getCopilotResultsOriginTableViewId, getStore, isCatchUpFilter, isCopilotResultsTable, isHeadlinesFilter, isNeedsReplyView, isPriorityView, type MailFolderTableQuery, type TableView } from "owa-mail-list-store";
import { getMailboxInfo } from "owa-mail-mailboxinfo";
import isAttachmentsSearchFolder from "owa-mail-store/lib/utils/isAttachmentsSearchFolder";

export default function shouldShowFavoriteToggle(mailboxInfo: MailboxInfo, tableView: TableView | undefined): boolean {
    // Copilot results use a synthetic folder ID, so eligibility comes from the originating table.
    const folderTableView = isCopilotResultsTable(tableView?.tableQuery)
        ? (getStore().tableViews.get(getCopilotResultsOriginTableViewId(mailboxInfo) ?? "") ??
            tableView)
        : tableView;
    const folderTableQuery = folderTableView?.tableQuery as MailFolderTableQuery | undefined;
    const folderId = folderTableQuery?.folderId;
    const scenarioType = folderTableQuery?.scenarioType;
    const isFolderScenario = scenarioType === "mail" ||
        scenarioType === "searchFolder" ||
        scenarioType === "mailFolderSortBySize";
    
    return !!(folderId &&
        isFolderScenario &&
        !isCatchUpFilter(folderTableQuery) &&
        !isHeadlinesFilter(folderTableQuery) &&
        !isAttachmentsSearchFolder(folderId) &&
        isCapabilitySupported(favoritesCapability, mailboxInfo) &&
        !(isPrioritizeOnDemandOn(getMailboxInfo(folderTableView)) &&
            isPriorityView(folderTableQuery)) &&
        !isNeedsReplyView(folderTableQuery));
}
